/**
 * Remove all non-numeric chars
 *
 * @param {string} value The string to clean
 * @returns {string}
 * @example
 * preFormatFilterNumericOnly('asdf1a23asdf);
 * //=> '123'
 */
export var preFormatFilterNumericOnly = function (value) { return value.replace(/\D/g, ''); };
